import { render } from "./GradeSelect.vue?vue&type=template&id=204c3df5&scoped=true"
import script from "./GradeSelect.vue?vue&type=script&lang=js"
export * from "./GradeSelect.vue?vue&type=script&lang=js"

import "./GradeSelect.vue?vue&type=style&index=0&id=204c3df5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204c3df5"]])

export default __exports__